import { Collapse, Space } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SingleLineEllipsis } from '../../styles';

const AntPanel = Collapse.Panel;

export const Panel = styled(AntPanel)`
  & .ant-collapse-header {
    display: flex;
    align-items: center;
    padding: 0 var(--layout-04) 0 0;
    background-color: var(--white-100);
  }

  & .ant-collapse-header:hover {
    background: var(--hover-color);
    border-color: var(--hover-color);
  }

  & .ant-collapse-content-box {
    padding: 0;
  }
`;

const StyledStrong = styled.p<{ strongTitle?: boolean }>`
  ${SingleLineEllipsis};
  font-weight: ${(props) =>
    props.strongTitle
      ? 'var(--heading-6-weight)'
      : 'var(--font-weight-normal)'};
  margin: 0;
  margin-right: var(--spacing-01);
`;

interface PanelHeaderTitleProps {
  icon?: ReactNode;
  title?: string | ReactNode;
  size?: SizeType | number;
  noOfItems?: number | undefined;
  endIcon?: ReactNode;
  strongTitle?: boolean;
}

export const PanelHeaderTitle: FC<PanelHeaderTitleProps> = ({
  icon,
  title,
  size = 0,
  noOfItems,
  endIcon,
  strongTitle = true,
}) => (
  <Space size={size}>
    {icon}
    <StyledStrong strongTitle={strongTitle}>{title}</StyledStrong>
    {noOfItems ? <StyledStrong>({noOfItems})</StyledStrong> : <></>}
    {endIcon != null && endIcon}
  </Space>
);
